import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { AltinnApplication } from '../../models/altinn-application/altinn-application';
import { OAuthService } from 'angular-oauth2-oidc';
import { AuthorizationService } from '../../services/authorization.service';

@Component({
  selector: 'unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class UnauthorizedComponent implements OnInit {

  @Input() application!: AltinnApplication;

  constructor(private readonly oauthService: OAuthService,
    private readonly authorizationService: AuthorizationService,
  ) {
  }

  ngOnInit(): void {
    if (this.oauthService.hasValidAccessToken())
      this.authorizationService.handleUnauthorizedInAltinn(this.application.applicationID);
  }
}
